import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { ClockIcon } from "Shared/Icons";
import "../Datepicker/Datepicker.scss";
import "./Timepicker.scss";
import { AppointmentTime } from "Types/api/Appointment";

interface TimepickerProps {
    placeholderText: string | undefined;
    reportUp: (date: any) => void;
    value: undefined | AppointmentTime.InTheMorning | AppointmentTime.InTheAfternoon | AppointmentTime.InTheEvening;
}

class OSTimepicker extends Component<TimepickerProps & WithTranslation> {
    public render() {
        const { t } = this.props;

        return (
            <div className="OSDatepicker OSTimepicker">
                <select
                    required
                    className="OSDatepicker__input"
                    placeholder={this.props.placeholderText ?? t("Timepicker.placeholder")}
                    value={this.props.value ?? ""}
                    onChange={this.handleChange}
                >
                    <option value="" disabled>
                        {this.props.placeholderText ?? t("Timepicker.placeholder")}
                    </option>
                    <option value={AppointmentTime.InTheMorning}>{t("Timepicker.morningLabel")}</option>
                    <option value={AppointmentTime.InTheAfternoon}>{t("Timepicker.afternoonLabel")}</option>
                    <option value={AppointmentTime.InTheEvening}>{t("Timepicker.eveningLabel")}</option>
                </select>
                <ClockIcon />
            </div>
        );
    }

    private handleChange = (event: any) => {
        this.props.reportUp(event.target.value);
    };
}

export default withTranslation()(OSTimepicker);
